import { render, staticRenderFns } from "./ProductInventory.vue?vue&type=template&id=e975e4ee&scoped=true&"
import script from "./ProductInventory.vue?vue&type=script&lang=js&"
export * from "./ProductInventory.vue?vue&type=script&lang=js&"
import style0 from "./ProductInventory.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductInventory.vue?vue&type=style&index=1&id=e975e4ee&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e975e4ee",
  null
  
)

export default component.exports